module.exports = __webpack_public_path__ + "static/service-4-f3472087924adf7ddc166db029a117e6.png";